module.exports = __webpack_public_path__ + "img/banner_desktop.8d28e8b4.png";